export const API_BASE = process.env.REACT_APP_API_BASE;

export const GENERIC_REQUEST_ERROR = 'GENERIC_REQUEST_ERROR';
